import { FC, useEffect } from "react"
import { useFetch } from "Hooks";
import { TUseFetch, TWebDocumentDTO } from "Types";
import { AsynchronousWrapper, WebDocument } from "Components";
import { PendoHelperSingleton } from "Helpers";
import { LoggingConstants } from "Constants";

type TDecoupledWebDocumentsProps = {
    ids: string[]
}

export const DecoupledWebDocuments: FC<TDecoupledWebDocumentsProps> = ({ids}: TDecoupledWebDocumentsProps) => {
    // Build url by adding id array query param
    let url = "api/articles/science?";
    ids.forEach((id: string, index: number) => {
        url += `ids[]=${id}`;
        if (index + 1 < ids.length) url += "&";
    });

    // We use `useFetch` custom hook here
    // to fetch data from the server
    const { isLoading, didError, errorMessage, fetchedData }: TUseFetch<TWebDocumentDTO[]> = useFetch(url);

    // Logging
    useEffect(() => {
        PendoHelperSingleton.trackEvent(`${LoggingConstants.DYNAMIC_DELIVERY}ArticlesGetDecoupledWebpages`);
    }, [url]);

    return (
        <AsynchronousWrapper didError={didError} errorMessage={errorMessage} isLoading={isLoading} LoaderComponent={null}>
            { !fetchedData ? <h3>Loading</h3>
                :
                <div>
                    {
                        fetchedData.map((documentDto) => {
                            return (
                                <WebDocument key={documentDto.id} webDto={documentDto} />
                            );
                        })
                    }

                </div>
            }  
        </AsynchronousWrapper>
    );
}